module.exports = __webpack_public_path__ + "img/SIA_poa.6fcdd74e.jpg";